/**
 * Lead Model
 * Represents a sales lead with validation and helper methods
 */

class Lead {
    constructor(data = {}) {
      this.id = data.id || data._id || null;
      this._id = data._id || data.id || null;
      this.firstName = data.firstName || '';
      this.lastName = data.lastName || '';
      this.email = data.email || '';
      this.phone = data.phone || '';
      this.company = data.company || '';
      this.jobTitle = data.jobTitle || '';
      this.leadSource = data.leadSource || 'Website';
      this.status = data.status || 'New';
      this.priority = data.priority || 'Medium';
      this.estimatedValue = data.estimatedValue || 0;
      this.assignedTo = data.assignedTo || null;
      this.notes = data.notes || '';
      this.tags = data.tags || [];
      this.createdAt = data.createdAt || new Date().toISOString();
      this.updatedAt = data.updatedAt || new Date().toISOString();
      this.lastContactedAt = data.lastContactedAt || null;
    }
  
    getFullName() {
      return `${this.firstName} ${this.lastName}`.trim();
    }
  
    isHotLead() {
      return this.priority === 'High' && this.estimatedValue > 100000;
    }
  
    getDaysSinceCreation() {
      const created = new Date(this.createdAt);
      const now = new Date();
      const diffTime = Math.abs(now - created);
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    }
  
    getStatusColor() {
      const colors = {
        'New': '#3b82f6',
        'Contacted': '#f59e0b',
        'Qualified': '#10b981',
        'Unqualified': '#ef4444',
        'Converted': '#8b5cf6'
      };
      return colors[this.status] || '#6b7280';
    }
  
    getPriorityColor() {
      const colors = {
        'High': '#ef4444',
        'Medium': '#f59e0b',
        'Low': '#3b82f6'
      };
      return colors[this.priority] || '#6b7280';
    }
  
    validate() {
      const errors = [];
  
      if (!this.firstName?.trim()) errors.push('First name is required');
      if (!this.lastName?.trim()) errors.push('Last name is required');
      if (!this.email?.trim()) {
        errors.push('Email is required');
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
        errors.push('Email is invalid');
      }
      if (!this.phone?.trim()) {
        errors.push('Phone is required');
      } else if (!/^[0-9]{10}$/.test(this.phone.replace(/\D/g, ''))) {
        errors.push('Phone must be 10 digits');
      }
      if (this.estimatedValue < 0) errors.push('Estimated value cannot be negative');
  
      return { isValid: errors.length === 0, errors };
    }
  
    toJSON() {
      return {
        id: this.id,
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        phone: this.phone,
        company: this.company,
        jobTitle: this.jobTitle,
        leadSource: this.leadSource,
        status: this.status,
        priority: this.priority,
        estimatedValue: this.estimatedValue,
        assignedTo: this.assignedTo,
        notes: this.notes,
        tags: this.tags,
        createdAt: this.createdAt,
        updatedAt: this.updatedAt,
        lastContactedAt: this.lastContactedAt
      };
    }
  
    static fromJSON(json) {
      return new Lead(json);
    }
  }
  
  export default Lead;